export var CardItemType;
(function (CardItemType) {
    CardItemType["AGENT_AVAILABILITY"] = "AGENT-AVAILABILITY";
    CardItemType["ARTICLE_LIST"] = "ARTICLE-LIST";
    CardItemType["CHANNEL_SELECTOR"] = "CHANNEL-SELECTOR";
    CardItemType["CONVERSATION_LIST"] = "CONVERSATION-LIST";
    CardItemType["HELP_CENTER_SEARCH_BAR"] = "HELP-CENTER-SEARCH-BAR";
    CardItemType["MAIL_FORM"] = "MAIL-FORM";
    CardItemType["WHATSAPP_CONNECT"] = "WHATSAPP-CONNECT";
    CardItemType["WHATSAPP_CONTACT_FORM"] = "WHATSAPP-CONTACT-FORM";
    CardItemType["START_NEW_CONVERSATION"] = "START-NEW-CONVERSATION";
    CardItemType["SEND_EMAIL_BUTTON"] = "SEND-EMAIL-BUTTON";
})(CardItemType || (CardItemType = {}));
